// extracted by mini-css-extract-plugin
module.exports = {"recipe":"recipe_recipe__1ozV5","image":"recipe_image__209uI"};